import { type CountryCode } from '@constants'
import { useApiMerchantsSearch } from '@hooks-api/fortune/useApiMerchantsSearch'
import { useApiPartnerProfile } from '@hooks-api/fortune-fastpass/useApiPartnerProfile'
import { type MerchantsSearchRequest, type PartnerProfileRequest } from '@hooks-api/types/apiRequest'
import { useMemo } from 'react'

export interface Option {
  label: string
  value: number | null
  billingCountry: CountryCode | null
}

interface UseAutocompleteMerchantOptionsArgs {
  isShopManager: boolean
  merchantsSearchRequest: MerchantsSearchRequest
  partnerProfileRequest: PartnerProfileRequest
}

export const useAutocompleteMerchantOptions = (args: UseAutocompleteMerchantOptionsArgs) => {
  const { isShopManager, merchantsSearchRequest, partnerProfileRequest } = args
  const { destructuredData: merchants } = useApiMerchantsSearch(isShopManager ? merchantsSearchRequest : undefined)
  const { destructuredData: partnerProfile } = useApiPartnerProfile(!isShopManager ? partnerProfileRequest : undefined)
  const options: Option[] = useMemo(() => {
    if (isShopManager) {
      return merchants?.map(merchant => ({
        label: merchant.billing_first_name,
        value: merchant.index,
        billingCountry: merchant.country_code,
      })) || []
    }
    return partnerProfile
      ? [{
        label: partnerProfile?.billing_address_first_name,
        value: partnerProfile?.id,
        billingCountry: partnerProfile?.billing_country,
      }]
      : []
  }, [isShopManager, merchants, partnerProfile])

  return options
}
